import {combineReducers, compose, createStore, applyMiddleware} from "redux";
import createSagaMiddleware from "@redux-saga/core";
import {logger, crashReporter} from "../../../store";
import rootSaga from "../sagas";

import {subsidiariesList, subsidiariesLoading} from "../reducers/subsidiaries.reducer";
import {
    presetsList,
    presetsLoading,
    presetLoading,
    initialPreset,
    submitPresetLoading,
    submittingPresetState,} from "../reducers/presets.reducer";

const specialPrizesPresetsReducer = combineReducers({
    subsidiariesList,
    subsidiariesLoading,
    presetsList,
    presetsLoading,
    presetLoading,
    initialPreset,
    submitPresetLoading,
    submittingPresetState,
});

const composeEnhancers = window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]
    ? window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]({
        name: "Special Prizes Presets Store"
    })
    : compose;


const sagaMiddleware = createSagaMiddleware();

export const specialPrizesPresetsStore = createStore(
    specialPrizesPresetsReducer,
    {},
    composeEnhancers(applyMiddleware(sagaMiddleware, logger, crashReporter))
);


export const specialPrizesPresetsStoreSelectors = {
    subsidiariesList: (state = specialPrizesPresetsStore.getState()) => state.subsidiariesList,
    subsidiariesLoading: (state = specialPrizesPresetsStore.getState()) => state.subsidiariesLoading,
    presetsList: (state = specialPrizesPresetsStore.getState()) => state.presetsList,
    presetsLoading: (state = specialPrizesPresetsStore.getState()) => state.presetsLoading,
    presetLoading: (state = specialPrizesPresetsStore.getState()) => state.presetLoading,
    initialPreset: (state = specialPrizesPresetsStore.getState()) => state.initialPreset,
    submitPresetLoading: (state = specialPrizesPresetsStore.getState()) => state.submitPresetLoading,
    submittingPresetState: (state = specialPrizesPresetsStore.getState()) => state.submittingPresetState,
}

sagaMiddleware.run(rootSaga);